import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  AdminResponseForTeacherRequestForm,
  DateFilterWithPagination,
  TeacherOnlineMinutesReportForm,
  TeacherUpdateRequestForm,
} from 'src/app/shared/interfaces';

import { Constants } from '../../common';
import { DataWithPagination } from '../../interface';
import { Mapper } from '../mapper/mapper';
import { TeacherOnlineMinutesReport, TeacherUpdateInfoRequestModel } from '../model';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export class TeachersUpdateInfoApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getTeachersUpdateInfoRequests(
    filter: DateFilterWithPagination
  ): Observable<DataWithPagination<TeacherUpdateInfoRequestModel[]>> {
    return this.baseAPI.post(Constants.GET_TEACHERS_UPDATE_INFO_REQUESTS_API_URL, filter).pipe(
      map((res) => {
        const itemsAfterFiltration = res.items.filter(
          (item) =>
            item?.briefEnStatus == 'pending' ||
            item?.avatarUrlStatus == 'pending' ||
            item?.briefStatus == 'pending' ||
            item?.certificateStatus == 'pending' ||
            item?.languagesStatus == 'pending' ||
            item?.ejazaStatus == 'pending' ||
            item?.nameArStatus == 'pending' ||
            item?.nameEnStatus == 'pending' ||
            item?.categoriseStatus == 'pending' ||
            item?.sessionPriceStatus == 'pending' ||
            item?.sessionLongPriceStatus == 'pending' ||
            item?.yearsOfExperienceStatus == 'pending'
        );
        res.count = res.count - (res.items.length - itemsAfterFiltration.length);
        const data: DataWithPagination<TeacherUpdateInfoRequestModel[]> = {
          data: this.mapper.fromListJson(TeacherUpdateInfoRequestModel, itemsAfterFiltration),
          count: res.count,
        };
        return data;
      })
    );
  }

  adminFeedBackForTeachersRequest(form: TeacherUpdateRequestForm): Observable<string> {
    return this.baseAPI
      .post(Constants.ADMIN_SUBMIT_ADMIN_PARTIAL_FEEDBACK_API_URL, form)
      .pipe(map((res) => res.message));
  }

  adminResponseForTeacherRequest(form: AdminResponseForTeacherRequestForm): Observable<string> {
    return this.baseAPI
      .post(Constants.ADMIN_RESPONSE_FOR_TEACHER_REQUEST_API_URL, form)
      .pipe(map((res) => res.message));
  }
}
